import { getLocalizedString } from 'i18n/utils';
import { INGREDIENT, HALF_STUFF } from 'utils/constants';

export const PRODUCT_TYPES = [INGREDIENT, HALF_STUFF].map(item => ({
  name: item,
  label: getLocalizedString(`ingredient.data.switcher.${item}`),
}));
